/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Styles */
import './RatingInformation.scss';

/* Utils */
import { getRating, isSelfClassified } from '../../../../utils/metaDataUtils';

function RatingInformation({ className, content }) {
  return !!content?.rating && (
    <div className={`dtv-html5-c-rating-information ${className}`}>
      <div className="dtv-html5-c-rating-information__rating">
        {getRating(content)}
      </div>
      {!isSelfClassified(content) && (
        <div className="dtv-html5-c-rating-information__metadata">
          <p className="dtv-html5-c-rating-information__description">
            {content?.ratingDescription}
          </p>
          <p className="dtv-html5-c-rating-information__warning">
            {content?.ratingWarning?.join(', ')}
          </p>
        </div>
      )}
    </div>
  );
}

RatingInformation.propTypes = {
  className: PropTypes.string,
  content: PropTypes.shape({
    rating: PropTypes.string,
    ratingDescription: PropTypes.string,
    ratingWarning: PropTypes.arrayOf(PropTypes.string),
  }),
};

RatingInformation.defaultProps = {
  className: '',
  content: undefined,
};

export default memo(RatingInformation);
